// Klucz w localStorage, pod którym pamiętany jest wybrany język wydarzeń —
// współdzielony przez Rejestracja/2/3/4, żeby wybór przetrwał nawigację
// między tymi stronami.
export const EVENT_LANG_STORAGE_KEY = 'hardadv_event_lang';

const LANGUAGES: Array<{ code: string; label: string }> = [
    { code: 'pl', label: 'PL' },
    { code: 'en', label: 'EN' },
];

export interface EventLanguageSwitcherProps {
    lang: string;
    onChange: (lang: string) => void;
}

// Przełącznik języka treści wydarzeń (tytuł/opis/lokalizacja/nazwy opcji).
// Celowo dotyczy tylko wydarzeń — reszta strony (formularz, nawigacja) zostaje po polsku.
export function EventLanguageSwitcher({ lang, onChange }: EventLanguageSwitcherProps) {
    return (
        <div className="event-language-switcher" role="group" aria-label="Język wydarzeń">
            {LANGUAGES.map((option) => (
                <button
                    key={option.code}
                    type="button"
                    className={`event-language-switcher__btn${lang === option.code ? ' event-language-switcher__btn--active' : ''}`}
                    onClick={() => onChange(option.code)}
                    aria-pressed={lang === option.code}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
